export class Rfs__consultation{

  static send_new_book(){};

  static sidebar_consultation(){};

  static modal_success_dialog(){};

  static time_box_group_individual(){};

  static appointment_provider(){};

  static chooseAdviser(){};
  static adviserCard(){};

}
